<template>
  <div class="footer_block">
    <img src="@/assets/home/logo2.png" class="logo" alt="" />
    <div class="footer_1">
      <div class="title">全国服务热线</div>
      <div class="title">400-8280-681</div>
      <div class="text">ZXZNZY.COM 座享乐舒的分类信息平台</div>
      <div @click="openIcpRecord" class="openIcptext">江苏座享智能科技有限公司.</div>
      <div @click="openIcpRecord" class="openIcptext">-苏ICP备19070843号-3</div>
    </div>
    <div class="footer_2">
      <div class="title">联系我们</div>
      <div class="text">邮箱：758583486@qq.com</div>
      <div class="text">地址：江苏省无锡市滨湖区建筑路583号汇创大厦2幢16层</div>
      <div>法律声明 | 网站地图</div>
    </div>
    <div class="footer_3">
      <div class="title">快速链接</div>
      <div class="text">首页</div>
      <div class="text">二手转让</div>
      <div>招商加盟</div>
      <div>发布信息</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WebsiteFooter",

  data() {
    return {
      // ICP备案查询链接
      icpRecordUrl: "https://beian.miit.gov.cn/",
    };
  },

  mounted() {},

  methods: {
    // 打开ICP备案查询页面
    openIcpRecord() {
      // 在新窗口打开工信部备案查询网站
      window.open(this.icpRecordUrl, "_blank");

      // 如果是移动端或需要特殊处理，可以使用以下方式：
      // this.openInNewTab(this.icpRecordUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer_block {
  padding: 50px 240px 20px;
  box-sizing: border-box;
  width: 100%;
  color: #fff;
  background: #0187ff;
  height: 280px;
  display: flex;
  justify-content: space-evenly;
  .logo {
    width: 160px;
    height: 120px;
    object-fit: cover;
  }
  .openIcptext {
    cursor: pointer;
  }
  .openIcptext:hover {
    text-decoration: underline;
  }
  .footer_1 {
    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .text {
      font-size: 14px;
      margin: 10px 0;
    }
  }
  .footer_2,
  .footer_3 {
    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
  .footer_3 {
  }
}
/* 手机端布局 */
@media (max-width: 767px) {
  .footer_block {
    padding: 30px 20px 20px;
    height: auto;
    flex-direction: column;
    align-items: center;
    text-align: center;
    
    .logo {
      width: 120px;
      height: 90px;
      margin-bottom: 20px;
    }
    
    .footer_1,
    .footer_2,
    .footer_3 {
      width: 100%;
      margin-bottom: 25px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
    
    .footer_1 {
      .title {
        font-size: 16px;
        margin-bottom: 8px;
      }
      
      .title:nth-child(2) {
        font-size: 20px;
        margin-bottom: 15px;
        color: #fff;
      }
      
      .text {
        font-size: 13px;
        margin: 8px 0;
        line-height: 1.4;
      }
      
      .openIcptext {
        font-size: 12px;
        line-height: 1.5;
        padding: 2px 0;
      }
    }
    
    .footer_2,
    .footer_3 {
      .title {
        font-size: 16px;
        margin-bottom: 12px;
      }
      
      .text,
      div:not(.title) {
        font-size: 13px;
        margin-bottom: 8px;
        line-height: 1.4;
      }
      
      .text:last-child {
        margin-bottom: 0;
      }
    }
    
    .footer_2 {
      div:last-child {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.9);
        margin-top: 5px;
      }
    }
    
    .footer_3 {
      .text,
      div:not(.title) {
        font-size: 13px;
        margin-bottom: 8px;
        cursor: pointer;
        transition: opacity 0.3s;
        
        &:active {
          opacity: 0.7;
        }
      }
    }
  }
}

/* 超小屏幕手机（iPhone SE等） */
@media (max-width: 375px) {
  .footer_block {
    padding: 25px 15px 20px;
    
    .logo {
      width: 100px;
      height: 75px;
      margin-bottom: 15px;
    }
    
    .footer_1 {
      .title:nth-child(2) {
        font-size: 18px;
      }
      
      .openIcptext {
        font-size: 11px;
      }
    }
  }
}

/* 横屏模式优化 */
@media (max-width: 767px) and (orientation: landscape) {
  .footer_block {
    padding: 20px 15px 15px;
    flex-direction: row;
    flex-wrap: wrap;
    text-align: left;
    
    .logo {
      width: 100px;
      height: auto;
      margin-bottom: 15px;
      margin-right: 20px;
    }
    
    .footer_1,
    .footer_2,
    .footer_3 {
      width: calc(50% - 20px);
      margin-bottom: 15px;
      
      &:nth-child(2) {
        margin-right: 20px;
      }
      
      &:nth-child(3) {
        width: 100%;
        text-align: center;
        margin-bottom: 10px;
      }
      
      &:nth-child(4) {
        width: 100%;
        text-align: center;
        margin-bottom: 0;
      }
    }
  }
}
</style>
